import { useState, useEffect, useMemo } from 'react';
import sortBy from 'lodash/sortBy';
import { useSelector } from 'react-redux';
import { RootState } from '../data/store';
import { TemplateMapping } from '../data/models/template';
import { fetchProjectConfigurations } from '../services/project-configuration.service';
import { ProjectConfiguration } from '../data/models/projectConfiguration';

const MAX_TEMPLATES = 999;

function useConfigurationsList(open: boolean) {
	const { astroToken } = useSelector((state: RootState) => state.authState);
	const [list, setList] = useState<ProjectConfiguration[]>([]);
	const [initialized, setInitialized] = useState<boolean>(false);

	useEffect(() => {
		const fetchConfigurationsForDropdown = async () => {
			const configurations = await fetchProjectConfigurations({
				searchText: '',
				order: 'name',
				direction: 'DESC',
				page: 0,
				take: MAX_TEMPLATES,
				// where: {},
			});
			setList(configurations.list);
			setInitialized(true);
		};
		if (astroToken && open) {
			fetchConfigurationsForDropdown();
		}
	}, [astroToken, open]);

	const dropdownOptions = useMemo(() => {
		return sortBy(
			list.map((mapping: any) => ({
				id: mapping.nameId,
				display: mapping.name,
			})),
			['display']
		);
	}, [list]);

	const dropdownOptionsFullData = useMemo(() => {
		return sortBy(
			list.map((template: ProjectConfiguration) => ({
				...template,
				id: template.nameId,
				display: template.name,
			})),
			['display']
		);
	}, [list]);

	return {
		list,
		dropdownOptions,
		dropdownOptionsFullData,
		initialized,
	};
}

export default useConfigurationsList;
